import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type JobcardManpowerModalContext = {
  jobcardId: string;
  jobcardNo?: string;
  vehicleMake?: string;
  model?: string;
  regNo?: string;
  customerName?: string;
  /** Full summary row from job card list — used for the details panel at top of modal */
  rowData?: Record<string, unknown>;
};

export interface JobcardManpowerModalState {
  isOpen: boolean;
  context: JobcardManpowerModalContext | null;
}

const initialState: JobcardManpowerModalState = {
  isOpen: false,
  context: null,
};

const jobcardManpowerModalSlice = createSlice({
  name: "jobcardManpowerModal",
  initialState,
  reducers: {
    openJobcardManpowerModal: (
      state,
      action: PayloadAction<JobcardManpowerModalContext>
    ) => {
      state.isOpen = true;
      state.context = action.payload;
    },
    closeJobcardManpowerModal: (state) => {
      state.isOpen = false;
      state.context = null;
    },
  },
});

export const { openJobcardManpowerModal, closeJobcardManpowerModal } =
  jobcardManpowerModalSlice.actions;

export default jobcardManpowerModalSlice.reducer;
